// extracted by mini-css-extract-plugin
export default {"banner":"ZjXr9","banner-background--light":"gLi4q","banner-img":"ttRcU","banner-content":"qDpz9","banner-content__icon":"cqteO","banner-content__icon--light":"uGbz7"};